import React, { useState, useEffect } from "react";
import vendorAPI from "../api/vendorAPI";
import VendorForm from "./VendorForm";
import { useVendorTerms } from "../utils/terminology";

const VendorModal = ({ isOpen, onClose, onCreated, onSaved, initialName = "", initialVendor = null }) => {
  const term = useVendorTerms();
  const isEditMode = Boolean(initialVendor?._id);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSaving(false);
    }
  }, [isOpen]);

  const handleSave = async (payload) => {
    try {
      setSaving(true);

      const res = isEditMode
        ? await vendorAPI.updateVendor(initialVendor._id, payload)
        : await vendorAPI.createVendor(payload);
      const created = res?.data || res;

      if (!created?._id) {
        throw new Error(`Vendor ${isEditMode ? "update" : "creation"} failed (no _id returned).`);
      }

      const selectedVendor = {
        _id: created._id,
        name: created.name,
        code: created.code,
        tin: created.tin,
        label: created.tin ? `${created.name} (TIN: ${created.tin})` : created.name,
        defaultAtcCode2306: created.defaultAtcCode2306,
        defaultAtcCode2307: created.defaultAtcCode2307,
        defaultWithholdingRate2306: created.defaultWithholdingRate2306,
        defaultWithholdingRate2307: created.defaultWithholdingRate2307,
        vendorType: created.vendorType,
        businessType: created.businessType,
        address: created.address || "",
        city: created.city || "",
        contactInfo: created.contactInfo || "",
        status: created.status || "active",
      };

      if (isEditMode) {
        onSaved?.(selectedVendor);
      } else {
        onCreated?.(selectedVendor);
      }
      onClose?.();
    } catch (e) {
      throw e; // Re-throw so VendorForm can handle it
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div className="relative w-full max-w-xl bg-white rounded-lg shadow-xl border border-gray-200 max-h-screen overflow-y-auto">
        <div className="px-5 py-4 border-b">
          <div className="text-lg font-semibold text-gray-800">{isEditMode ? `Edit ${term.one}` : `Create ${term.one}`}</div>
          <div className="text-xs text-gray-500 mt-1">
            {isEditMode
              ? `Update ${term.lower} details. TIN is optional but must be 10-12 digits if provided.`
              : `Add a ${term.lower} to your masterlist. TIN is optional but must be 10-12 digits if provided.`}
          </div>
        </div>

        <div className="p-5">
          <VendorForm
            initialVendor={initialVendor}
            initialName={!isEditMode ? initialName : undefined}
            onSave={handleSave}
            onCancel={onClose}
            saving={saving}
            showButtons={true}
          />
        </div>
      </div>
    </div>
  );
};

export default VendorModal;
